import React from "react";

function RefundPolicy() {
  return (
    <div className="flex justify-center pb-[50px] lg:px-[20px]">
      <div className="w-[90vw] sm:w-[600px] md:w-[700px] lg:w-[800px] lg:mr-[300px] break-normal">
        <div className="pt-[50px] lg:pt-[100px] pb-[20px]">
          <h className="text-[40px] font-semibold">Refund Policy</h>
        </div>
        <div className="flex flex-col gap-[20px] text-[17px] font-[sans-serif] text-[#838f9d] pb-[40px]">
          <li>
            If you cancel your registration within 24 hour after you got
            registered on this website, you will automatically receive a refund
            equivalent to half of the registration fee. The remainder of your
            payment will be retained to cover expenses for processing your
            registration and holding space at our data base.
          </li>
          <li>
            If you reschedule or cancel services purchased by You, not later
            than 24 hour of purchase of service, a nominal deduction (20%) shall
            be made and balance amount shall be refunded.
          </li>
          <li>
            If you reschedule or cancel services purchased by You, after 24 hour
            of purchase of service but not more than 3 days (including the day
            of purchase of service) deduction (25%) shall be made and balance
            amount shall be refunded.
          </li>
          <li>
            If you reschedule or cancel services purchased by You, after 3 days
            of purchase of service (including the day of purchase of service)
            but not more than 10 days (including the day of purchase of service)
            deduction (50%) shall be made and balance amount shall be refunded.
          </li>
          <li>
            If you reschedule or cancel services purchased by you, after 10 days
            (including the day of purchase of service) no refund shall be made
            until and unless it is proved that you have not been served for what
            you have made payment.
          </li>
        </div>
        <div className="flex flex-col gap-[20px] text-[17px] font-[sans-serif] text-[#838f9d]">
          <p>
            In case, after 30 days of purchase of services, refund shall be made
            as per our policy on grievance redressal.
          </p>
          <li>
            Refund will be processed directly in your Bank / Credit Card account
            that was used to make the payment.
          </li>
          <li>Cash refunds are not available.</li>
          <li>
            Refunds will not be given if you do not follow proper registration
            procedures and/or fail to present the required identification
            documents.
          </li>
          <li>
            In case your credit card/debit card/payment account has been
            accidentally over-charged, please notify our Help and Support Team
            of the same at the earliest. Refund of the over-charged amount shall
            be made in your original Account within 15 working days. In the
            reverse scenario service shall not be activated by Us until full
            payment is made.
          </li>
          <li>No interest is paid on a refund of any amount.</li>
          <li>
            You should contact Help and Support Team first, regarding any excess
            or double payment made by them.
          </li>
          <li>
            The refund of any fee is subject to the refund policy prevailing at
            the time of seeking a refund.
          </li>
          <li>
            We reserves the right to modify and amend refund policies at any
            time by uploading the same in the website.
          </li>
          <li>
            All dispute shall first be. settled amicably and You agree that, you
            shall place your complaint to our Help and Support Team at
            sales@modelopedia.com
          </li>
          <li>
            All disputes that cannot be settled amicably are subject to the
            legal jurisdiction of District Court Ernamkulam, Kerala, (India).
          </li>
        </div>
      </div>
    </div>
  );
}

export default RefundPolicy;
